<app-page-modal-container showHeader="false" [enableScroll]="false">
    <ng-container *ngTemplateOutlet="header" />
    <div class="flex w-full h-full">
        <app-document-side-section class="w-full lg:w-auto" />
        <ng-container *ngTemplateOutlet="right" />
    </div>
</app-page-modal-container>

<ng-template #header>
    <div
        [class.safe-top]="platform !== 'web'"
        class="bg-[#373853] flex w-full justify-between items-center px-6 py-4"
    >
        <div class="lg:w-[23rem] w-full justify-between flex items-center">
            <div class="flex gap-2 items-center">
                <img src="logo-gray.png" alt="logo" />
                <p class="text-white">문서함</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #right>
    <div class="hidden w-full h-full lg:block">
        @if (currentTicket() || type()) {
            <div class="w-full h-full">
                <router-outlet />
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="noTicket" />
        }
    </div>
</ng-template>

<ng-template #noTicket>
    <div class="flex justify-center items-center w-full h-full bg-gray-100">
        <div class="flex flex-col gap-2.5 items-center">
            <app-icon name="tabler:mood-kid-filled" class="text-gray-400" />
            <p class="text-gray-500">아동을 선택해주세요.</p>
        </div>
    </div>
</ng-template>
